import { useEffect, useState } from "react";

export const useLocalStorage = (key, initialValue) => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState();

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      if (typeof window != "undefined") {
        const valueToStore =
          value instanceof Function ? value(storedValue) : value;
        // Save state
        setStoredValue(valueToStore);
        // Save to local storage
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.error(error);
    }
  };

  useEffect(() => {
    setStoredValue(() => {
      try {
        // Get from local storage by key
        if (typeof window != "undefined") {
          const item = window.localStorage.getItem(key);
          return typeof item != "undefined" && item != "undefined" && item
            ? JSON.parse(item)
            : initialValue;
        }
      } catch (error) {
        // If error also return initialValue
        console.error(error);
        return initialValue;
      }
    });
  }, []);
  return [storedValue, setValue];
};
